import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const box = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.sm} ${theme.borderRadius.lg};

  svg {
    width: ${size[40]};
    height: ${size[40]};

    circle {
      display: none;
    }
  }
`

export const content = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${size[8]};
    text-align: left;
  }

  p {
    margin: 0;
  }
`

export const primary = (theme: Theme) => css`
  background-color: ${theme.palette.primary.lowContrast};
  color: ${theme.palette.primary.mainContrast};
`

export const secondary = (theme: Theme) => css`
  background-color: ${theme.palette.background.main};
  color: #828b99;
`
